// extracted by mini-css-extract-plugin
export var Testimonial = "Testimonial-module--Testimonial--YX+EM";
export var Testimonial_container = "Testimonial-module--Testimonial_container--pRVaL";
export var Testimonial_container_content = "Testimonial-module--Testimonial_container_content--qM90v";
export var Testimonial_container_item = "Testimonial-module--Testimonial_container_item--vFRSD";
export var Testimonial_container_item_avatar = "Testimonial-module--Testimonial_container_item_avatar--SyWSE";
export var Testimonial_container_item_handle = "Testimonial-module--Testimonial_container_item_handle--t63Q6";
export var Testimonial_container_item_text = "Testimonial-module--Testimonial_container_item_text--NTR7w";
export var Testimonial_container_link = "Testimonial-module--Testimonial_container_link--CxNO9";
export var Testimonial_container_link_svg = "Testimonial-module--Testimonial_container_link_svg--65CqY";
export var Testimonial_container_text = "Testimonial-module--Testimonial_container_text--nPc7R";
export var container = "Testimonial-module--container--8x9GI";
export var gatsbyImageWrapperConstrained = "Testimonial-module--gatsby-image-wrapper-constrained--NVyik";
export var gridSpan1010 = "Testimonial-module--grid-span-10-10--T8rlL";
export var gridSpan1011 = "Testimonial-module--grid-span-10-11--V1ZBX";
export var gridSpan102 = "Testimonial-module--grid-span-10-2--xeIjH";
export var gridSpan103 = "Testimonial-module--grid-span-10-3--SqV4M";
export var gridSpan104 = "Testimonial-module--grid-span-10-4--pakjl";
export var gridSpan105 = "Testimonial-module--grid-span-10-5--Fcfj-";
export var gridSpan106 = "Testimonial-module--grid-span-10-6--SAn-5";
export var gridSpan107 = "Testimonial-module--grid-span-10-7--l7yFD";
export var gridSpan108 = "Testimonial-module--grid-span-10-8--ZVw3Y";
export var gridSpan109 = "Testimonial-module--grid-span-10-9--NOgaI";
export var gridSpan110 = "Testimonial-module--grid-span-1-10--kejcW";
export var gridSpan111 = "Testimonial-module--grid-span-1-11--fGx3O";
export var gridSpan1110 = "Testimonial-module--grid-span-11-10---6rtz";
export var gridSpan1111 = "Testimonial-module--grid-span-11-11--4NG8s";
export var gridSpan112 = "Testimonial-module--grid-span-11-2--AloAz";
export var gridSpan113 = "Testimonial-module--grid-span-11-3--sHHGW";
export var gridSpan114 = "Testimonial-module--grid-span-11-4--EiVuL";
export var gridSpan115 = "Testimonial-module--grid-span-11-5--b2g7V";
export var gridSpan116 = "Testimonial-module--grid-span-11-6--NWD7k";
export var gridSpan117 = "Testimonial-module--grid-span-11-7--HUaHy";
export var gridSpan118 = "Testimonial-module--grid-span-11-8--O3EqD";
export var gridSpan119 = "Testimonial-module--grid-span-11-9--06Vcg";
export var gridSpan12 = "Testimonial-module--grid-span-1-2--q+uS3";
export var gridSpan1210 = "Testimonial-module--grid-span-12-10--6LNjR";
export var gridSpan1211 = "Testimonial-module--grid-span-12-11--4fp9k";
export var gridSpan122 = "Testimonial-module--grid-span-12-2--JUBLP";
export var gridSpan123 = "Testimonial-module--grid-span-12-3--pkvcs";
export var gridSpan124 = "Testimonial-module--grid-span-12-4--G+kRH";
export var gridSpan125 = "Testimonial-module--grid-span-12-5--3llzi";
export var gridSpan126 = "Testimonial-module--grid-span-12-6--1dN78";
export var gridSpan127 = "Testimonial-module--grid-span-12-7--eZJM2";
export var gridSpan128 = "Testimonial-module--grid-span-12-8--TyRW8";
export var gridSpan129 = "Testimonial-module--grid-span-12-9--dI6nJ";
export var gridSpan13 = "Testimonial-module--grid-span-1-3--4Hg1P";
export var gridSpan14 = "Testimonial-module--grid-span-1-4--Z1ZYC";
export var gridSpan15 = "Testimonial-module--grid-span-1-5--PMcBq";
export var gridSpan16 = "Testimonial-module--grid-span-1-6--l4syf";
export var gridSpan17 = "Testimonial-module--grid-span-1-7--vmY5m";
export var gridSpan18 = "Testimonial-module--grid-span-1-8--l2GQc";
export var gridSpan19 = "Testimonial-module--grid-span-1-9--52Js1";
export var gridSpan210 = "Testimonial-module--grid-span-2-10--9gnSc";
export var gridSpan211 = "Testimonial-module--grid-span-2-11--k4tBH";
export var gridSpan22 = "Testimonial-module--grid-span-2-2--6xNOf";
export var gridSpan23 = "Testimonial-module--grid-span-2-3--8Fvvi";
export var gridSpan24 = "Testimonial-module--grid-span-2-4--IYO2x";
export var gridSpan25 = "Testimonial-module--grid-span-2-5--ILlul";
export var gridSpan26 = "Testimonial-module--grid-span-2-6--HA0qI";
export var gridSpan27 = "Testimonial-module--grid-span-2-7--73hk-";
export var gridSpan28 = "Testimonial-module--grid-span-2-8--dhG0q";
export var gridSpan29 = "Testimonial-module--grid-span-2-9--zi+Lv";
export var gridSpan310 = "Testimonial-module--grid-span-3-10--LtwZy";
export var gridSpan311 = "Testimonial-module--grid-span-3-11--TEHno";
export var gridSpan32 = "Testimonial-module--grid-span-3-2--HY2Xb";
export var gridSpan33 = "Testimonial-module--grid-span-3-3--RaQaq";
export var gridSpan34 = "Testimonial-module--grid-span-3-4--a+gMu";
export var gridSpan35 = "Testimonial-module--grid-span-3-5---Ujxa";
export var gridSpan36 = "Testimonial-module--grid-span-3-6--Wgrlm";
export var gridSpan37 = "Testimonial-module--grid-span-3-7--zgqdC";
export var gridSpan38 = "Testimonial-module--grid-span-3-8--crrrj";
export var gridSpan39 = "Testimonial-module--grid-span-3-9--8JVEq";
export var gridSpan410 = "Testimonial-module--grid-span-4-10--adk86";
export var gridSpan411 = "Testimonial-module--grid-span-4-11--KoLkV";
export var gridSpan42 = "Testimonial-module--grid-span-4-2--0cCTh";
export var gridSpan43 = "Testimonial-module--grid-span-4-3--Xy5rb";
export var gridSpan44 = "Testimonial-module--grid-span-4-4--MdpdI";
export var gridSpan45 = "Testimonial-module--grid-span-4-5--0ge9a";
export var gridSpan46 = "Testimonial-module--grid-span-4-6--8J4wJ";
export var gridSpan47 = "Testimonial-module--grid-span-4-7--EA3ld";
export var gridSpan48 = "Testimonial-module--grid-span-4-8--5mDEa";
export var gridSpan49 = "Testimonial-module--grid-span-4-9--VgaEp";
export var gridSpan510 = "Testimonial-module--grid-span-5-10--GMRG4";
export var gridSpan511 = "Testimonial-module--grid-span-5-11--n+cUA";
export var gridSpan52 = "Testimonial-module--grid-span-5-2--vuQdr";
export var gridSpan53 = "Testimonial-module--grid-span-5-3--ZoK6C";
export var gridSpan54 = "Testimonial-module--grid-span-5-4--cY7CR";
export var gridSpan55 = "Testimonial-module--grid-span-5-5--zMLL7";
export var gridSpan56 = "Testimonial-module--grid-span-5-6--XkMEe";
export var gridSpan57 = "Testimonial-module--grid-span-5-7--AiLFe";
export var gridSpan58 = "Testimonial-module--grid-span-5-8--ZQV7n";
export var gridSpan59 = "Testimonial-module--grid-span-5-9--oMEyL";
export var gridSpan610 = "Testimonial-module--grid-span-6-10--ydj3e";
export var gridSpan611 = "Testimonial-module--grid-span-6-11--3SkqW";
export var gridSpan62 = "Testimonial-module--grid-span-6-2--Roqs5";
export var gridSpan63 = "Testimonial-module--grid-span-6-3--4VZoq";
export var gridSpan64 = "Testimonial-module--grid-span-6-4--OGzgf";
export var gridSpan65 = "Testimonial-module--grid-span-6-5--o8z8f";
export var gridSpan66 = "Testimonial-module--grid-span-6-6--teo+r";
export var gridSpan67 = "Testimonial-module--grid-span-6-7--AHYem";
export var gridSpan68 = "Testimonial-module--grid-span-6-8--XHnEr";
export var gridSpan69 = "Testimonial-module--grid-span-6-9--GTOiH";
export var gridSpan710 = "Testimonial-module--grid-span-7-10--IO7xg";
export var gridSpan711 = "Testimonial-module--grid-span-7-11--1BDDQ";
export var gridSpan72 = "Testimonial-module--grid-span-7-2--wrum3";
export var gridSpan73 = "Testimonial-module--grid-span-7-3--5AhI-";
export var gridSpan74 = "Testimonial-module--grid-span-7-4--CW2Xn";
export var gridSpan75 = "Testimonial-module--grid-span-7-5--EXEfc";
export var gridSpan76 = "Testimonial-module--grid-span-7-6--PjQGn";
export var gridSpan77 = "Testimonial-module--grid-span-7-7--A7qig";
export var gridSpan78 = "Testimonial-module--grid-span-7-8--BPujf";
export var gridSpan79 = "Testimonial-module--grid-span-7-9--0Un0Z";
export var gridSpan810 = "Testimonial-module--grid-span-8-10--tJcIY";
export var gridSpan811 = "Testimonial-module--grid-span-8-11--QFdvm";
export var gridSpan82 = "Testimonial-module--grid-span-8-2--yXHGx";
export var gridSpan83 = "Testimonial-module--grid-span-8-3--m1x5s";
export var gridSpan84 = "Testimonial-module--grid-span-8-4--5h+6r";
export var gridSpan85 = "Testimonial-module--grid-span-8-5--wBDtB";
export var gridSpan86 = "Testimonial-module--grid-span-8-6--pjH5h";
export var gridSpan87 = "Testimonial-module--grid-span-8-7--jNcyZ";
export var gridSpan88 = "Testimonial-module--grid-span-8-8--piOze";
export var gridSpan89 = "Testimonial-module--grid-span-8-9--EgOgq";
export var gridSpan910 = "Testimonial-module--grid-span-9-10--oq829";
export var gridSpan911 = "Testimonial-module--grid-span-9-11--umv-F";
export var gridSpan92 = "Testimonial-module--grid-span-9-2--jsFzH";
export var gridSpan93 = "Testimonial-module--grid-span-9-3---zA1J";
export var gridSpan94 = "Testimonial-module--grid-span-9-4--wDbe2";
export var gridSpan95 = "Testimonial-module--grid-span-9-5--qcXc-";
export var gridSpan96 = "Testimonial-module--grid-span-9-6--v+-ej";
export var gridSpan97 = "Testimonial-module--grid-span-9-7--DPVko";
export var gridSpan98 = "Testimonial-module--grid-span-9-8--3H81y";
export var gridSpan99 = "Testimonial-module--grid-span-9-9--R5Jo0";
export var textBreak = "Testimonial-module--text-break--x5dvg";